import React from 'react';
import { TreeEntry } from './types';
import { TreeCheckboxBaseNode } from './hooks';

function escapeRegExp(string: string): string {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function getSearchDisplayLabel(item: TreeEntry, regex: RegExp): React.ReactNode {
  const matches = item.label.split(regex);
  const result: React.ReactNode[] = [];
  for (let i = 0; i < matches.length; i += 2) {
    result.push(matches[i]);
    if (i < matches.length - 1) {
      result.push(<b>{matches[i + 1]}</b>);
    }
  }
  return result;
}

export function filterTreeItems(
  items: TreeEntry[],
  keyword: string,
): {
  items: TreeEntry[];
  expandedIds: string[];
} {
  if (keyword.trim() === '') {
    return { items, expandedIds: [] };
  }
  const regex = new RegExp(`(${escapeRegExp(keyword.trim())})`, 'i');
  const expandedIds: string[] = [];
  function walk(item: TreeEntry, inclusive = false): TreeEntry[] {
    if (regex.test(item.label)) {
      const children = item?.children?.flatMap((child) => walk(child, true));
      const childrenWithMatches = item?.children?.flatMap((child) => walk(child, false));
      if (childrenWithMatches != null && childrenWithMatches.length > 0) {
        expandedIds.push(item.id);
      }
      return [{ ...item, displayLabel: getSearchDisplayLabel(item, regex), children }];
    }
    const children = item?.children?.flatMap((child) => walk(child));
    if (children != null && children.length > 0) {
      expandedIds.push(item.id);
      return [{ ...item, children }];
    } else if (inclusive) {
      return [item];
    } else {
      return [];
    }
  }
  return { items: items.flatMap((child) => walk(child)), expandedIds };
}

export function getFullyExpandedIds(items: TreeCheckboxBaseNode[], targetIds: string[]): string[] {
  const expandedIds: string[] = [];
  function walk(item: TreeCheckboxBaseNode): boolean {
    if (targetIds.includes(item.id)) {
      expandedIds.push(item.id);
      return true;
    }
    const hasChildren = item?.children?.some((child) => walk(child)) ?? false;
    if (hasChildren) {
      expandedIds.push(item.id);
    }
    return hasChildren;
  }
  items.forEach((child) => walk(child));
  return expandedIds;
}
